import { User } from "interfaces/user";
import {
	GetUserAction,
	SetUserAction,
	UserActionTypes,
} from "./types";

export function getUser(): GetUserAction {
	return {
		type: UserActionTypes.GET_USER,
	};
}

export function setUser(payload: User | null): SetUserAction {
	return {
		type: UserActionTypes.SET_USER,
		payload,
	};
}
